var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 81,
    viewBox: "0 0 179 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 139,
    height: 41,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M85.976 46H81.53V33.544H85.976C88.004 33.544 89.348 34.348 90.008 35.956C90.392 36.88 90.584 38.092 90.584 39.592C90.584 42.724 89.804 44.698 88.244 45.514C87.62 45.838 86.864 46 85.976 46ZM89.162 39.592C89.162 37.204 88.628 35.716 87.56 35.128C87.128 34.888 86.6 34.768 85.976 34.768H82.916V44.776H85.976C88.1 44.776 89.162 43.048 89.162 39.592ZM99.0176 44.884L99.5396 44.83L99.5756 45.892C98.2076 46.084 97.0376 46.18 96.0656 46.18C94.7696 46.18 93.8516 45.808 93.3116 45.064C92.7716 44.308 92.5016 43.138 92.5016 41.554C92.5016 38.398 93.7556 36.82 96.2636 36.82C97.4756 36.82 98.3816 37.162 98.9816 37.846C99.5816 38.518 99.8816 39.58 99.8816 41.032L99.8096 42.058H93.8696C93.8696 43.054 94.0496 43.792 94.4096 44.272C94.7696 44.752 95.3936 44.992 96.2816 44.992C97.1816 44.992 98.0936 44.956 99.0176 44.884ZM98.5316 40.978C98.5316 39.874 98.3516 39.094 97.9916 38.638C97.6436 38.182 97.0676 37.954 96.2636 37.954C95.4716 37.954 94.8716 38.194 94.4636 38.674C94.0676 39.154 93.8636 39.922 93.8516 40.978H98.5316ZM102.093 46V33.076H103.443V46H102.093ZM112.271 44.884L112.793 44.83L112.829 45.892C111.461 46.084 110.291 46.18 109.319 46.18C108.023 46.18 107.105 45.808 106.565 45.064C106.025 44.308 105.755 43.138 105.755 41.554C105.755 38.398 107.009 36.82 109.517 36.82C110.729 36.82 111.635 37.162 112.235 37.846C112.835 38.518 113.135 39.58 113.135 41.032L113.063 42.058H107.123C107.123 43.054 107.303 43.792 107.663 44.272C108.023 44.752 108.647 44.992 109.535 44.992C110.435 44.992 111.347 44.956 112.271 44.884ZM111.785 40.978C111.785 39.874 111.605 39.094 111.245 38.638C110.897 38.182 110.321 37.954 109.517 37.954C108.725 37.954 108.125 38.194 107.717 38.674C107.321 39.154 107.117 39.922 107.105 40.978H111.785ZM119.849 38.17H116.987V42.472C116.987 43.504 117.059 44.182 117.203 44.506C117.359 44.83 117.719 44.992 118.283 44.992L119.885 44.884L119.975 46C119.171 46.132 118.559 46.198 118.139 46.198C117.203 46.198 116.555 45.97 116.195 45.514C115.835 45.058 115.655 44.188 115.655 42.904V38.17H114.377V37H115.655V34.246H116.987V37H119.849V38.17ZM127.617 44.884L128.139 44.83L128.175 45.892C126.807 46.084 125.637 46.18 124.665 46.18C123.369 46.18 122.451 45.808 121.911 45.064C121.371 44.308 121.101 43.138 121.101 41.554C121.101 38.398 122.355 36.82 124.863 36.82C126.075 36.82 126.981 37.162 127.581 37.846C128.181 38.518 128.481 39.58 128.481 41.032L128.409 42.058H122.469C122.469 43.054 122.649 43.792 123.009 44.272C123.369 44.752 123.993 44.992 124.881 44.992C125.781 44.992 126.693 44.956 127.617 44.884ZM127.131 40.978C127.131 39.874 126.951 39.094 126.591 38.638C126.243 38.182 125.667 37.954 124.863 37.954C124.071 37.954 123.471 38.194 123.063 38.674C122.667 39.154 122.463 39.922 122.451 40.978H127.131Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7857 37.3333V46.2222H49.2143V37.3333H57.7857ZM56.1786 32H50.8214L49.75 32.8889H46V34.6667H61V32.8889H57.25L56.1786 32ZM59.9286 35.5556H47.0714V46.2222C47.0714 47.2 48.0357 48 49.2143 48H57.7857C58.9643 48 59.9286 47.2 59.9286 46.2222V35.5556Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 179,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.89f639ef86195ec3e1cef467095cd351.svg";
export { ForwardRef as ReactComponent };